var map = {
	"./mario.png": "./src/static/data/mario.png",
	"./mealhop.png": "./src/static/data/mealhop.png",
	"./myProjects": "./src/static/data/myProjects.json",
	"./myProjects.json": "./src/static/data/myProjects.json",
	"./nlu_ibm.png": "./src/static/data/nlu_ibm.png",
	"./paint4me.png": "./src/static/data/paint4me.png",
	"./particlebois.gif": "./src/static/data/particlebois.gif",
	"./reminders.png": "./src/static/data/reminders.png",
	"./resume.pdf": "./src/static/data/resume.pdf",
	"./shapez.gif": "./src/static/data/shapez.gif",
	"./soundpong.gif": "./src/static/data/soundpong.gif",
	"./website.png": "./src/static/data/website.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/static/data sync recursive ^\\.\\/.*$";